import React, { useContext, useState, useEffect, Suspense } from "react";
import {
  Box,
  VStack,
  Flex,
  Input,
  Text,
  Button,
  Td,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Select,
  Stack,
  useDisclosure,
  Center,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import C_Modal from "./C_Modal";
import EditClassModal from "./Edit_clas"; // Import the EditClassModal component
import {
  FaEllipsisV,
  FaPlus,
  FaSort,
  FaSortUp,
  FaSortDown,
} from "react-icons/fa"; // Import sort icons
import { BASE_URL } from "../../Globalapi/Globalapi";

// Lazy load the AssignTeacherDrawer component
const AssignTeacherDrawer = React.lazy(() => import("./Assign_T"));

const List = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isDrawerOpen,
    onOpen: onDrawerOpen,
    onClose: onDrawerClose,
  } = useDisclosure();
  const [classData, setClassData] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null); // State to store selected class ID
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // State for Edit Class Modal
  const [sortDirection, setSortDirection] = useState("asc"); // State for sorting direction
  const [fetchEnabled, setFetchEnabled] = useState(true);

  const [sortOption, setSortOption] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate(); // Initialize useNavigate
  const [isAutoFetchEnabled, setIsAutoFetchEnabled] = useState(true);

  // const [searchTerm, setSearchTerm] = useState('');
  const [searchCategory, setSearchCategory] = useState("class");
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setSearchCategory(e.target.value);
  };

  useEffect(() => {
    if (!fetchEnabled) return; // Skip fetching if sort is active
    const intervalId = setInterval(fetchClassData, 2000);

    return () => clearInterval(intervalId);
  }, [fetchEnabled]);
  useEffect(() => {
    fetchClassData();
  }, []);
  useEffect(() => {
    fetchClassData();
  }, []); // Fetch only once on component mount

  const fetchClassData = async () => {
    try {
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await fetch(
        `${BASE_URL}/admin/class/list_all_class.php?school_id=${school_id}`
      );
      const data = await response.json();
      // console.log("Fetched Data:", data);
      if (data && data.success && Array.isArray(data.data)) {
        setClassData(data.data); // Access the data key inside the response object
      }
    } catch (error) {
      console.error("Error fetching class data:", error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchClassData(); // Fetch data every 2 seconds
    }, 2000);

    return () => clearInterval(intervalId); // Cleanup on component unmount
  }, []);

  // Handle the actions from the dropdown menu
  const handleMenuAction = async (action, classId) => {
    setSelectedClassId(classId);
    switch (action) {
      case "assignTeacher":
        if (classId) onDrawerOpen();
        break;
      case "editClass":
        if (classId) setIsEditModalOpen(true);
        break;
      case "removeTeacher":
        if (classId) {
          try {
            const response = await fetch(
              `${BASE_URL}/admin/class/remove_class_teacher.php`,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ class_details_id: classId }),
              }
            );

            const result = await response.json();

            if (result.success) {
              console.log(result.message);
              fetchClassData(); // Refresh the class data after removal
            } else {
              console.error(result.message);
            }
          } catch (error) {
            console.error("Error removing class teacher:", error);
          }
        }
        break;
      case "deleteClass":
        if (classId) {
          console.log("delet id in ", classId);

          try {
            // Prepare the request payload
            const payload = {
              class_details_id: classId,
              pass: sessionStorage.getItem("user_id"), // Replace userId with the actual logged-in user ID
            };

            // Make the DELETE request
            fetch(`${BASE_URL}/admin/class/delete_class.php`, {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(payload),
            })
              .then((response) => response.json())
              .then((data) => {
                if (data.success) {
                  console.log(
                    `Class ${classId} deleted successfully:`,
                    data.message
                  );
                } else {
                  console.log(
                    `Failed to delete class ${classId}:`,
                    data.message
                  );
                }
              })
              .catch((error) => {
                console.error("Error deleting class:", error);
              });
          } catch (error) {
            console.error("Error in deleteClass:", error);
          }
        } else {
          console.error("No classId provided for deletion.");
        }
        break;

      default:
        break;
    }
  };
  useEffect(() => {
    if (!isAutoFetchEnabled) return; // Skip refetching if sorting is active

    const intervalId = setInterval(fetchClassData, 2000);
    return () => clearInterval(intervalId);
  }, [isAutoFetchEnabled]);

  const handleSort = (key) => {
    const isSameKey = sortOption === key;
    const direction = isSameKey
      ? sortDirection === "asc"
        ? "desc"
        : "asc"
      : "asc";

    setSortDirection(direction);
    setSortOption(key);
    setFetchEnabled(false); // Disable auto-fetch when sorting

    const sortedData = [...classData].sort((a, b) => {
      if (key === "class") {
        // Define the strict order for 'class'
        const classOrder = [
          "Pre KG",
          "I",
          "II",
          "III",
          "IV",
          "V",
          "VI",
          "VII",
          "VIII",
          "IX",
          "X",
        ];

        // Sort based on the predefined order and direction
        const indexA = classOrder.indexOf(a[key]);
        const indexB = classOrder.indexOf(b[key]);

        // If sorting ascending, Pre KG should come first, otherwise X should come last
        return direction === "asc" ? indexA - indexB : indexB - indexA;
      } else if (key === "section") {
        // Handle section sorting (if applicable)
        const sectionOrder = ["KG", "LP", "UP", "HS"];
        return direction === "asc"
          ? sectionOrder.indexOf(a[key]) - sectionOrder.indexOf(b[key])
          : sectionOrder.indexOf(b[key]) - sectionOrder.indexOf(a[key]);
      } else {
        // Generic sorting for other columns
        return direction === "asc"
          ? a[key] > b[key]
            ? 1
            : -1
          : a[key] < b[key]
          ? 1
          : -1;
      }
    });

    setClassData(sortedData);
  };

  const getSortIcon = (key) => {
    if (sortOption !== key) return <FaSort />;
    return sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />;
  };

  // Optional: Add a button to manually refresh data if needed
  const handleRefresh = () => {
    setFetchEnabled(true);
    fetchClassData();
  };
  const filteredClassData = classData.filter((classItem) => {
    if (searchCategory === "class") {
      return classItem.class.toLowerCase().includes(searchTerm.toLowerCase());
    }
    if (searchCategory === "division") {
      return classItem.division
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
    }
    if (searchCategory === "teacher") {
      return classItem.name?.toLowerCase().includes(searchTerm.toLowerCase());
    }

    return true; // No filter applied if no category selected (fallback)
  });

  return (
    <Box p={6} borderRadius="md" mx="auto" bg="white">
      <Flex
        justify="space-between"
        align="center"
        p={3}
        className="sb"
        direction={{ base: "column", md: "row" }}
      >
        {/* Search Inputs */}
        <Flex
          width="100%"
          align="center"
          spacing={4}
          direction={{ base: "column", md: "row" }}
          justify="flex-end" // Align items to the right side
        >
          {/* Dropdown to select search category */}
          <Select
            mt={{ base: "2" }}
            value={searchCategory}
            onChange={handleCategoryChange}
            marginRight={2}
            width={{ base: "100%", md: "100px" }}
          >
            <option value="class">Class</option>
            <option value="division">Division</option>
            <option value="teacher">Teacher</option>
          </Select>

          {/* Input field for the search term */}
          <Input
            mt={{ base: "2" }}
            placeholder={`Search by ${
              searchCategory.charAt(0).toUpperCase() + searchCategory.slice(1)
            }`}
            value={searchTerm}
            onChange={handleSearchChange}
            width={{ base: "100%", md: "150px" }}
          />
        </Flex>
      </Flex>

      {/* Table displaying class data */}
      <div style={{ overflowX: "auto" }}>
        <Table
          sx={{
            "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
          }}
        >
          <Thead>
            <Tr>
              <Th onClick={() => handleSort("class")}>
                <Box textAlign="center">
                  <Flex justify="space-between" align="center">
                    Class
                    {getSortIcon("class")}
                  </Flex>
                </Box>
              </Th>
              <Th>
                <Box textAlign="center"></Box> Division
              </Th>
              <Th onClick={() => handleSort("section")}>
                <Flex justify="space-between" align="center">
                  Section
                  {getSortIcon("section")}
                </Flex>
              </Th>
              <Th>
                <Box textAlign="center">Min No of Students</Box>
              </Th>
              <Th>
                <Box textAlign="center">Max No of Students</Box>
              </Th>
              <Th>
                <Box textAlign="center">Assigned Teacher</Box>
              </Th>
              <Th>
                <Box textAlign="center">Action</Box>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredClassData.map((classItem) => (
              <Tr key={classItem.id}>
                <Td>
                  <Box textAlign="center">
                    <Button
                      variant="link"
                      onClick={() => navigate(`/class/${classItem.id}`)}
                    >
                      {classItem.class}
                    </Button>
                  </Box>
                </Td>
                <Td>
                  <Box textAlign="center"> {classItem.division}</Box>
                </Td>
                <Td>
                  <Box textAlign="center"> {classItem.section}</Box>
                </Td>
                <Td>
                  <Box textAlign="right"> {classItem.min_students}</Box>
                </Td>
                <Td>
                  <Box textAlign="right"> {classItem.max_students}</Box>
                </Td>
                <Td>
                  <Box textAlign="center">{classItem.name}</Box>
                </Td>

                <Td>
                  <Box textAlign="center">
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        size="sm"
                        variant="ghost"
                        icon={<FaEllipsisV />}
                      />
                      <MenuList>
                        <MenuItem
                          onClick={() =>
                            handleMenuAction("assignTeacher", classItem.id)
                          }
                        >
                          Assign Teacher
                        </MenuItem>
                        <MenuItem
                          onClick={() =>
                            handleMenuAction("removeTeacher", classItem.id)
                          }
                        >
                          Remove Teacher
                        </MenuItem>
                        {/* <MenuItem
                        onClick={() =>
                          handleMenuAction("editClass", classItem.id)
                        }
                      >
                        Edit
                      </MenuItem> */}
                        <MenuItem
                          onClick={() =>
                            handleMenuAction("deleteClass", classItem.id)
                          }
                        >
                          Delete
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Box>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </div>

      {/* Suspense to show a fallback while the drawer component is being loaded */}
      <Suspense fallback={<div>Loading...</div>}>
        <AssignTeacherDrawer
          isOpen={isDrawerOpen}
          onClose={onDrawerClose}
          classId={selectedClassId}
        />
      </Suspense>

      {/* Edit Class Modal */}
      <EditClassModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        classId={selectedClassId}
        fetchClassData={fetchClassData}
      />
    </Box>
  );
};

export default List;
